import{styled as t}from"@mui/material/styles";const i=t("div")((({theme:t})=>({textAlign:"center",marginBottom:t.spacing(12),[t.breakpoints.down("md")]:{marginBottom:t.spacing(6)}})));export{i as Header};
//# sourceMappingURL=styles.js.map
